<template>
  <div @click="$emit('click')" class="card background" :class="[type && `card-${type}`]">
    <div class="card-image" v-if="$slots.image">
      <slot name="image"></slot>
    </div>
    <div
      class="card-header"
      v-if="$slots.header || title"
      :class="headerClasses"
    >
      <slot name="header">
        <h4 class="card-title montserrat-title">{{ title }}</h4>
        <p class="card-category" v-if="subTitle">{{ subTitle }}</p>
      </slot>
    </div>
    <div class="card-body montserrat" v-if="$slots.default">
      <slot></slot>
    </div>
    <div class="card-image" v-if="$slots['image-bottom']">
      <slot name="image-bottom"></slot>
    </div>
    <slot name="raw-content"></slot>
    <div class="card-footer montserrat" :class="footerClasses" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "card",
  props: {
    title: {
      type: String,
      description: "Card title"
    },
    subTitle: {
      type: String,
      description: "Card subtitle"
    },
    type: {
      type: String,
      description: "Card type (e.g primary/danger etc)"
    },
    headerClasses: {
      type: [String, Object, Array],
      description: "Card header css classes"
    },
    bodyClasses: {
      type: [String, Object, Array],
      description: "Card body css classes"
    },
    footerClasses: {
      type: [String, Object, Array],
      description: "Card footer css classes"
    }
  }
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;600;700&display=swap');

.montserrat-title{
  font-family: "Montserrat";
  font-style: normal !important;
  font-weight: 700 !important;
  font-display: swap !important;
  color: #026A89 !important;
  text-align :center !important;
}
.montserrat{
  font-family: "Montserrat";
  font-style: normal !important;
  font-weight: 700 !important;
  font-display: swap !important;
  color: #0A2240 !important;
}
.background{
  background-color: #EEF9FA !important;
}
p{
  font-family: "Montserrat";
  font-style: normal !important;
  font-weight: 500 !important;
  font-display: swap !important;
  color: #0A2240 !important;
}
.input-label {
  display: flex;
  flex-direction: column;
  font-weight: 600;
}
.input {
  width: 100%;
  border: 1px solid #0F6A88;
  border-radius: 5px;
}
input[type="text"]
{
  font-family: "Montserrat" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-display: swap !important;
}
</style>
